import type { BiometryCalculateResponse, BiometryCurves, BiometryParams } from "@/types/biometry"
import { HttpClient, STATIC_ROOT } from "@/api/httpClient"

export default {
	curves() {
		return HttpClient.get<BiometryCurves>(`${STATIC_ROOT}/biometries/curves`)
	},
	calculate(param: BiometryParams, week: number, value: number) {
		return HttpClient.get<BiometryCalculateResponse>(`${STATIC_ROOT}/biometries/calculate`, {
			params: {
				curve: param,
				week,
				value
			}
		})
	}
}
